const TierValidation = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = "The name is required";
  }
  if (!values.status) {
    // You can return translation keys
    errors.status = "Status is required";
  }

  if (!values.tier_condition_value && values.tier_condition_value !== 0) {
    errors.tier_condition_value = "Money required is required";
  }

  if (!values.coupon_id) {
    errors.coupon_id = "Benefit is required";
  }
  if (!values.coupon_value && values.coupon_value !== 0) {
    errors.coupon_value = "Benefit value is required";
  }

  if (!values.level && values.level !== 0) {
    // You can return translation keys
    errors.level = "Level is required";
  }

  return errors;
};

export default TierValidation;
